import React from "react"
import { Wave } from "react-animated-text"
import styles from "./Team.module.css"
import DesignIllustration from "./DesignIllustration"

const DesignTeam = () => {
  const [width, setWidth] = React.useState()
  React.useEffect(() => {
    setWidth(window.innerWidth)
  }, [])
  const updateDimensions = () => {
    setWidth(window.innerWidth)
  }
  const updateWidth = () => {
    setWidth(window.innerWidth)
  }

  React.useEffect(() => {
    window.addEventListener("resize", updateWidth)
    return () => {
      window.removeEventListener("resize", updateDimensions)
    }
  }, [width])
  const text = `Design Team`
  return (
    <div className={styles.container}>
      {/* <div className={styles.containerContentTeam} ref={container}></div> */}
      {width > 768 && <DesignIllustration />}
      <div className={styles.subContainer}>
        <span className={styles.heading}>
          <Wave text={text} effect="stretch" iterations={1} effectChange={2} />
        </span>
        {width <= 768 && <DesignIllustration />}

        <span className={styles.para}>
          {" "}
          Let's bring out the creative designing skills inside your heart here.
          The attractive designing posters and extraordinary works you prepare
          will make the Club brighter and more colorful. The time you spend here
          melts sooner since the people who work here will be exciting and
          imaginative. The productivity inside you will help increase the Club's
          progress through the designs and art you prepare here. &nbsp;
          <a href="/team/design_team" rel="noreferrer">
            Know More...
          </a>
        </span>
      </div>
    </div>
  )
}

export default DesignTeam
